export const SCHEDULE_REGEX = /^((Lu|Ma|Mi|Ju|Vi|Sá|Sa|Do)(([,-])(Lu|Ma|Mi|Ju|Vi|Sá|Sa|Do))*\s+([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d(,\s*([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d)*)(;\s*(Lu|Ma|Mi|Ju|Vi|Sá|Sa|Do)(([,-])(Lu|Ma|Mi|Ju|Vi|Sá|Sa|Do))*\s+([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d(,\s*([01]\d|2[0-3]):[0-5]\d-([01]\d|2[0-3]):[0-5]\d)*)*$/i;

export const TARGET_FIELDS = [
    { key: 'status', label: 'Estado' },
    { key: 'owner', label: 'Owner' },
    { key: 'codigo', label: 'Código' },
    { key: 'codigo_brp', label: 'Código BRP' },
    { key: 'valor_administracion', label: 'Administración' },
    { key: 'disponibilidad_visitas', label: 'Horarios Visita' },
    { key: 'nombre_cliente', label: 'Nombre Cliente' },
    { key: 'telefono_cliente', label: 'Celular Cliente' },
    { key: 'correo_1', label: 'Correo Cliente' },
    { key: 'nombre_encargado', label: 'Nombre Encargado' },
    { key: 'telefono_encargado', label: 'Teléfono Encargado' },
    { key: 'observaciones_internas', label: 'Observaciones Internas' },
    { key: 'numero_matricula', label: 'No. Matrícula' },
    { key: 'numero_predial', label: 'No. Predial' },
    { key: 'piso', label: 'Piso' },
    { key: 'accion', label: 'Acción' },
];

export const INTERNAL_FIELD_MAP: Record<string, string> = {
    nombre_cliente: 'nombre_contacto',
    telefono_cliente: 'celular_contacto',
    correo_1: 'correo_contacto',
    codigo_brp: 'codigo_brp_o_inmobiliaria'
};